{
  "id": "gaia",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Gaia",
    "en": "Gaia"
  },
  "icon": "gods/gaia",
  "portrait": "gods/gaia-portrait",
  "modifiers": [
    {
      "target": "cost",
      "op": "mul",
      "value": 0.65,
      "scope": {
        "ids": [
          "economic-guild",
          "husbandry",
          "hand-axe",
          "pickaxe",
          "plow",
          "survival-equipment",
          "bow-saw",
          "shaft-mine",
          "irrigation",
          "carpenters",
          "quarry",
          "flood-control",
          "plow-gaia",
          "survival-equipment-gaia",
          "bow-saw-gaia",
          "shaft-mine-gaia",
          "irrigation-gaia",
          "carpenters-gaia",
          "quarry-gaia",
          "flood-control-gaia"
        ]
      },
      "note": "ArchaicAgeGaia: Economic Guild and Husbandry, Plow, Survival Equipment, Irrigation, Flood Control, Hand Axe, Bow Saw, Carpenters, Pickaxe, Shaft Mine, Quarry cost x0.65 Percent (both of each tech's resources)."
    },
    {
      "target": "promotionCost",
      "op": "pct",
      "value": -0.25,
      "scope": {
        "ids": ["citizen"]
      },
      "note": "VillagerAtlanteanToHero promotion cost x0.75 BasePercent (food, wood and favor): 48.75f 7.5w 1.5 favor."
    }
  ],
  "startExtras": {
    "units": {
      "citizen": 0,
      "citizen-hero": 2
    }
  },
  "powers": ["gaia-forest"],
  "minors": {
    "classical": ["leto", "oceanus"],
    "heroic": ["theia", "rheia"],
    "mythic": ["atlas", "hekate"]
  },
  "unlocks": [
    "channels",
    "plow-gaia",
    "survival-equipment-gaia",
    "bow-saw-gaia",
    "shaft-mine-gaia",
    "irrigation-gaia",
    "carpenters-gaia",
    "quarry-gaia",
    "flood-control-gaia"
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml ArchaicAgeGaia/ClassicalAgeGaia/HeroicAgeGaia)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Power: Gaia Forest (cooldown 120). startExtras REPLACES the 2 starting Citizens with 2 Citizen Heroes (major_gods.xml startingunits: 2 VillagerAtlanteanHero). Economic Guild techs one age earlier (Plow/Survival Equipment Archaic; Bow Saw/Shaft Mine/Irrigation Classical; Carpenters/Quarry/Flood Control Heroic): the '*-gaia' research entries. Not expressed: Lush terrain creep around Town/Village Centers, Manors, Economic Guilds and Markets."
  },
  "fieldMeta": {
    "modifiers": {
      "source": "Game files 19.17020 (techtree.xml ArchaicAgeGaia)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Economic Guild and its techs cost x0.65 Percent -> mul; Citizen promotion (VillagerAtlanteanToHero) food/wood/favor x0.75 BasePercent -> pct."
    }
  }
}
